module.exports = __webpack_public_path__ + "static/media/sale_01.688b0580.svg";